import Vue, { PluginObject } from "vue";

class PermissionsPlugin implements PluginObject<any> {
    install = (_Vue: typeof Vue, options?: any) => {
        _Vue.prototype.$check = function (user: any, requiredPermissions: string[]): boolean {
            if (!requiredPermissions || !requiredPermissions.length) return true;

            if (!user || !user.roles || !user.roles.permissions) {
                console.warn("Usuário ou permissões não definidas:", requiredPermissions);
                return false;
            }

            const userPermissions = user.roles.permissions.map((permission: any) => permission.key);

            if (userPermissions.includes("*")) return true;

            const hasPermission = requiredPermissions.some((permission) => {
                return (
                    userPermissions.includes(permission) ||
                    userPermissions.includes(permission + ".*") ||
                    userPermissions.includes(permission.split(".")[0] + ".*")
                );
            });

            return hasPermission
        };
    };

    [key: string]: any;
}

const plugin = new PermissionsPlugin();
Vue.use(plugin);
